module.exports = __webpack_public_path__ + "static/media/eden.f011fd98.jpg";